module.exports = __webpack_public_path__ + "videos/legacy_mob.3a2504d.mp4";